<div class="d-flex align-items-center gap-5">
  <i
    *ngIf="!isPDF"
    [ngbPopover]="paxBreakdownInfoTooltip"
    [autoClose]="'outside'"
    popoverClass="pax-breakdown-popover"
    placement="bottom"
    class="material-icons pax-breakdown-info-icon"
    container="body"
    #popover="ngbPopover"
  >
    {{buttonName}}
  </i>

  <ng-content></ng-content>
</div>


<ng-template #paxBreakdownInfoTooltip>
  <div class="pax-breakdown-info-tooltip-wp">
    <ng-container *ngIf="showOnlyFare">
      <ng-container *ngIf="consumerPrice?.breakdown">
        <div *ngFor="let pax of paxes | sortPassengers; last as last">
          <div class="d-flex justify-content-between">
            <span>{{ getTravelerTitle(pax.passengerType) }} </span>
            <span>
              {{ getPaxNumber(pax) }} x
              <span class="text-black"> {{pax.base | number :'1.2-2'}} {{consumerPrice.currency }}</span>
            </span>
          </div>
          <hr *ngIf="!last">
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="!showOnlyFare">
      <h4>{{ 'PAX_BREAKDOWN_POPOVER.TITLE' | translate }}</h4>
      <ng-container *ngIf="consumerPrice?.breakdown">
        <div *ngFor="let pax of paxes | sortPassengers; last as last">
          <div class="d-flex justify-content-between">
            <span>{{ getTravelerTitle(pax.passengerType) }} </span>
            <span>{{ getPaxNumber(pax) }} x <span class="text-black"> {{ getTotal(pax) }} {{consumerPrice.currency}} </span> </span>
          </div>
          <hr>
          <div class="d-flex justify-content-between">
            <span class="ml-3">{{ 'PAX_BREAKDOWN_POPOVER.FARE' | translate }}</span>
            <span class="text-black">{{pax.base | number :'1.2-2'}} {{consumerPrice.currency }}</span>
          </div>
          <hr>
          <div class="d-flex justify-content-between">
            <span class="ml-3">{{ 'PAX_BREAKDOWN_POPOVER.TAXES' | translate }}</span>
            <span class="text-black">{{pax?.total | number :'1.2-2'}} {{consumerPrice.currency }}</span>
          </div>
          <ng-container *ngIf="pax?.surcharge">
            <hr>
            <div class="d-flex justify-content-between">
              <span class="ml-3">{{ 'PAX_BREAKDOWN_POPOVER.SURCHARGE' | translate }}</span>
              <span class="text-black">{{pax.surcharge | number :'1.2-2'}} {{consumerPrice.currency }}</span>
            </div>
          </ng-container>
          <hr *ngIf="!last">
        </div>
        <ng-container *ngIf="consumerPrice.penalty?.total">
          <hr>
          <div class="d-flex justify-content-between text-nowrap">
            <span>Penalty</span>
            <span class="text-black">{{consumerPrice.penalty.total | number :'1.2-2'}} {{consumerPrice.currency }}</span>
          </div>
        </ng-container>
        <ng-container *ngIf="consumerPrice.fee?.total">
          <hr>
          <div class="d-flex justify-content-between text-nowrap">
            <span>{{ 'PAX_BREAKDOWN_POPOVER.FEES' | translate }}</span>
            <span class="text-black">{{consumerPrice.fee.total | number :'1.2-2'}} {{consumerPrice.currency }}</span>
          </div>
        </ng-container>
        <ng-container *ngIf="services?.length">
          <hr>
          <div class="d-flex justify-content-between text-nowrap">
            <span>{{ 'PAX_BREAKDOWN_POPOVER.SERVICES' | translate }}</span>
            <span class="text-black">{{servicesTotalPrice | number :'1.2-2'}} {{consumerPrice.currency }}</span>
          </div>
        </ng-container>
        <ng-container *ngIf="seats?.length">
          <hr>
          <div class="d-flex justify-content-between text-nowrap">
            <span>{{ 'PAX_BREAKDOWN_POPOVER.SEAT_SELECTION' | translate }}</span>
            <span class="text-black">{{seatsTotalPrice | number :'1.2-2'}} {{consumerPrice.currency }}</span>
          </div>
        </ng-container>
        <ng-container *ngIf="consumerPrice.discount?.description && consumerPrice.discount?.value">
          <hr>
          <div class="d-flex justify-content-between gap-30 text-nowrap">
            <span>{{consumerPrice.discount.description}}</span>
            <span class="text-black">- {{consumerPrice.discount.value}} {{consumerPrice.currency }}</span>
          </div>
        </ng-container>
        <ng-container *ngIf="serviceTotals?.length">
          <hr>
          <div *ngFor="let service of serviceTotals; last as last">
            <div class="d-flex justify-content-between">
              <span *ngIf="service.type === 'seat'">{{ 'PAX_BREAKDOWN_POPOVER.SEAT_SELECTION' | translate }}</span>
              <span *ngIf="service.type === 'service'">{{ 'PAX_BREAKDOWN_POPOVER.SERVICES' | translate }}</span>
              <span>
              <span class="text-black"> {{service.base | number :'1.2-2'}} {{consumerPrice.currency }}</span>
            </span>
            </div>
            <hr *ngIf="!last">
          </div>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="!consumerPrice?.breakdown">
        <div class="d-flex justify-content-between">
          <span>{{getTravelerTitle(passengerType) }}</span>
          <span class="text-black"> {{ consumerPrice.total }} {{consumerPrice.currency}} </span>
        </div>
        <hr>
        <div class="d-flex justify-content-between">
          <span class="ml-3">{{ 'PAX_BREAKDOWN_POPOVER.FARE' | translate }}</span>
          <span class="text-black">{{consumerPrice.base | number :'1.2-2'}} {{consumerPrice.currency }}</span>
        </div>
        <hr>
        <div class="d-flex justify-content-between">
          <span class="ml-3">{{ 'PAX_BREAKDOWN_POPOVER.TAXES' | translate }}</span>
          <span class="text-black">{{consumerPrice.tax?.total | number :'1.2-2'}} {{consumerPrice.currency }}</span>
        </div>
        <ng-container *ngIf="consumerPrice.fee?.total">
          <hr>
          <div class="d-flex justify-content-between">
            <span class="ml-3">{{ 'PAX_BREAKDOWN_POPOVER.FEES' | translate }}</span>
            <span class="text-black">{{consumerPrice.fee.total | number :'1.2-2'}} {{consumerPrice.currency }}</span>
          </div>
        </ng-container>
        <ng-container *ngIf="consumerPrice.surcharge">
          <hr>
          <div class="d-flex justify-content-between">
            <span class="ml-3">{{ 'PAX_BREAKDOWN_POPOVER.SURCHARGE' | translate }}</span>
            <span class="text-black">{{consumerPrice.surcharge | number :'1.2-2'}} {{consumerPrice.currency }}</span>
          </div>
        </ng-container>
        <ng-container *ngIf="consumerPrice.penalty?.total">
          <hr>
          <div class="d-flex justify-content-between text-nowrap">
            <span class="ml-3">Penalty</span>
            <span class="text-black">{{consumerPrice.penalty.total | number :'1.2-2'}} {{consumerPrice.currency }}</span>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
</ng-template>
